import React from 'react';
import { Card } from 'semantic-ui-react';
import OcrTasksTable from '../../components/OcrTasksTable';

const OcrTask = () => {
  return (
    <div className='dashboard-container'>
      <Card fluid className='chart-card'>
        <Card.Content>
          <Card.Header className='header'>OCR 任务</Card.Header>
          <p style={{ color: '#8a919f', marginTop: 0 }}>
            简历 OCR 解析任务（<code>/openapi/ocr/resume/submit</code>
            ）。计费口径：实际下发到节点才计费；命中 md 缓存 / 在途合并 / 排队期取消 /
            预取过期 / 终态失败均不计费（退还预扣）。预取任务（P2）到点未下发自动过期；
            正式请求命中在途预取任务会提级为正式（P5）。
          </p>
          <OcrTasksTable />
        </Card.Content>
      </Card>
    </div>
  );
};

export default OcrTask;
